import { put, takeLatest, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'

import Logger from '@Utils/Logger'
import { IAction } from '@Root/types'

import {
  createWorkspaceUsersSuccess,
  createWorkspaceUsersFailure,
  deleteWorkspaceUserSuccess,
  deleteWorkspaceUserFailure,
} from './actions'

import {
  WorkspaceUserActionTypes,
  ICreateWorkspaceUsersPayload,
  IDeleteWorkspaceUserPayload,
} from './types'

import {
  fetchAccountUsers,
} from '@SiteModules/AccountUser/actions'

import * as API from './api'

const call: any = Eff.call

function* createWorkspaceUsersSaga(action: IAction<ICreateWorkspaceUsersPayload>): Generator<any, any, any> {
  try {
    yield call(API.createWorkspaceUsers, action.payload)

    yield put(createWorkspaceUsersSuccess())
    toastr.success('', 'Workspace user(s) created')

    const state = yield select()
    yield put(fetchAccountUsers({ accountId: state.accounts.currentAccountId }))
  } catch (e) {
    Logger.error(e, 'Workspace user(s) could not be created')
    yield put(createWorkspaceUsersFailure())
  }
}

function* deleteWorkspaceUserSaga(action: IAction<IDeleteWorkspaceUserPayload>) {
  try {
    yield call(API.deleteWorkspaceUser, action.payload)

    yield put(deleteWorkspaceUserSuccess(action.payload))
    toastr.success('', 'Workspace user deleted')
  } catch (e) {
    Logger.error(e, 'Workspace user could not be deleted')
    yield put(deleteWorkspaceUserFailure())
  }
}

function* workspaceUsersSagas() {
  yield takeLatest(WorkspaceUserActionTypes.CREATE_WORKSPACE_USERS, createWorkspaceUsersSaga)
  yield takeLatest(WorkspaceUserActionTypes.DELETE_WORKSPACE_USER, deleteWorkspaceUserSaga)
}

export default workspaceUsersSagas
